export default {
  zh: {
    sendtipsmsg:'提醒短信',
    repaymentLink:'还款链接',
    username:'用户名',
    monayvalue:'金额',
    orderallmoney:'订单总金额',
    createOrderDate:'还款链接生成时间',
    ThaiName: '泰文姓名',
    ThaibmName: '泰文别名',
    contentValue: '内容',
    RegisPhoneNum: '注册电话',
    sendSmSSuccess:'发送成功',
    witnessScore: '人证识别分数',
    line: 'line',

    creator: '创建人姓名',
    notes: '备注',
    blackoutTime: '拉黑时间',

    tiktokNumber: 'TikTok 账号',
    Currentaddress:'现有住址',
    senfEmail: '发送邮件',
    saveEdit: '保存',
    cancelSaveEdit: '取消编辑',
    EditValue: '编辑',
    ProductType: '产品类型',
    title: '订单管理',
    allTitle: '全部订单',
    loanTitle: '已放款订单',
    pendingTitle: '待放款订单',
    overdueTitle: '逾期订单',
    repayReportTitle: '回款报表1',
    transformingDataExportTitle: '转化数据导出',
    orderNo: '订单编号',
    orderId: '订单ID',
    orderType: '订单类型',
    loanStatus: '放款状态',
    loanAmount: '放款金额',
    loanTime: '放款时间',
    loanPurpose: '借款用途',
    loanNumber: '借款次数',
    settlementStatus: '结清状态',
    settlementTime: '结清时间',
    overdueStatus: '逾期状态',
    applicationTime: '申请时间',
    applicationAmount: '申请金额',
    deadline: '期限',
    applicationDeadline: '申请期限',
    submissionTime: '提交时间',

    orderDetail: '订单详情',
    orderInfo: '订单信息',
    examineCustomerInfo: '审核客户信息',
    examineAddressInfo: '审核地址信息',
    approvalDetail: '审批详情',
    collectionDetail: '催收详情',
    repaymentPlan: '还款计划',
    historicalOrderRecords: '历史订单记录',
    jointBondOrderRecords: '共债订单记录',
    totalPeriod: '总期数',
    currentPeriod: '当前期数',
    startingTime: '开始时间',
    amount: '贷款额度',
    totalNumber: '总账户数量',
    totalAmounts: '未尝贷款总额',
    approveBorrowerTotal: '批准借款人总数',
    approveBorrowerTotalAmount: '批准借款人总金额',
    overdueAccountTotal: '未偿借款人总数',
    overdueAmountTotal: '未偿借款人总金额',
    addBorrowerTotal: '新增借款人总数',
    addBorrowerTotalAmount: '新增借款人总金额',
    approveBorrowContractTotal: '批准借款合同总数',
    approveBorrowContractTotalAmount: '批准借款合同总金额',
    overdueContractAccountTotal: '未偿借款合同总数',
    overdueContractAmountTotal: '未偿借款合同总金额',
    addBorrowContractTotal: '新增借款合同总数',
    addBorrowContractTotalAmount: '新增借款合同总金额',
    addAccountTotal: '新增账户数量',
    addAmountTotal: '新增贷款金额',
    overdueAccountTotal1: '逾期1~3月账户',
    overdueAccountTotal2: '逾期3~6月账户',
    overdueAccountTotal3: '逾期6~12月账户',
    overdueAccountTotal4: '逾期12月以上账户',
    overdueAmountTotal1: '逾期1~3月金额',
    overdueAmountTotal2: '逾期3~6月金额',
    overdueAmountTotal3: '逾期6~12月金额',
    overdueAmountTotal4: '逾期12月以上金额',
    expireTime: '到期时间',
    totalRepayableAmount: '应还总金额',
    principalPayable: '应还本金',
    overdueDays: '逾期天数',
    unpaidPrincipal: '未付本金',
    forfeitPenalty: '滞纳金',
    status: '状态',
    sxCreditScore: 'INX信用分',
    sxCheatScore: 'INX欺诈分',
    overdueDaysStart: '逾期天数(起)',
    overdueDaysEnd: '逾期天数(止)',

    collectionRecord: '催收记录',
    collectionStaff: '催收人',
    collectionTime: '催收时间',
    collectionTaskStatus: '催收任务状态',
    collectionStatus: '催收状态',
    collectionRemark: '备注',
    followUserName: '跟进人',
    followTime: '跟进时间',
    overdueDay: '逾期天数',
    followResult: '跟进结果',
    followingUpOrder: '跟进中订单',
    repaymentIntention: '还款意愿',
    hasColOrder: '持有订单数',

    approvalRecord: '审批记录',
    calllist:'本人通话记录',
    callusername:'话机用户名',
    calltimevalue:'通话时长(秒)',
    RecordingAccessAddress:'录音访问地址',
    connectionTime:'接通时间',
    hangingUpReason:'挂机原因',
    approvalStaff: '审批人员',
    approvalTime: '审批时间',
    approvalTaskStatus: '审批任务状态',
    approvalStatus: '审核状态',
    settleStatus: '还款状态',
    settleTime: '还款时间',
    repayment: '是否复贷',
    failedLoanOrder: '放款失败订单',
    approvalRemark: '备注',

    addressBookList: '通讯录列表',
    addressBookName: '联系人姓名',
    addressBookPhoneNo: '联系人姓名',

    lending: '放款',
    isLoan: '是否放款?',
    location: '定位地址',
    q1: '借款人电话是否接通',

    repaymentRecord: '还款记录',
    couponRecord:'优惠卷记录',
    flowRepayRecord: '还款跟踪记录',
    payOrderNo: '支付订单号',
    payOutId: '支付公司订单号',
    payInId: '内部支付订单号',
    payType: '支付类型',
    payAmount: '支付金额',
    payRecipt: '单据号',
    description: '描述',
    errorDescription: '失败描述',
    recordTime: '记录日期',
    updatedTime: '更新时间',
    channel: '渠道',
    productName: '产品名称',
    appVersion: 'app版本',
    questionType: '问题分类',
    isSettle: '是否进行线下还款?',
    isReductionAmt: '是否进行滞纳金减免?',
    isRefuseReductionAmt: '是否拒绝滞纳金申请?',
    branchType: 'branchType',
    curdate: '日期',
    dateCaliber: '日期口径',
    caseLoanName: '贷超名',
    regCount: '注册数',
    cardCustCount: '证件拍摄完成客户数',
    faceCount: '人脸识别客户数',
    baseCount: '基本信息完善客户数',
    linkManCount: '联系人完善客户数',
    applyCount: '申请数',
    bankCardCount: '绑卡客户数',
    approveCount: '通过数',
    loanCount: '放款数',
    reLendingAmount: '贷款次数',
    repayPoint: '贷款利率',
    overdueOrder: '逾期订单',
    overdueSettleOrder: '逾期未结清订单',
    custType: '用户类型',

    totalAmount: '总金额',
    applyAmt: '申请金额',
    loanDuration: '贷款天数',
    card: '身份证',
    repaymentAmount: '应还款金额',
    subRepaymentAmount: '减免后还款金额',
    settleAmt: '已还款金额',
    lateFee: '滞纳金',
    overdueDayC: '逾期天数',
    linkCondition: '通讯录和联系人情况',
    orderNumber: '用户或最近联系人电话号码',
    capital: '应还本金',
    settledCapital: '已还本金',
    settledInterest: '已还利息',
    interest: '利息',
    totalRemainingDebt: '剩余债务总额',
    remainingPrincipal: '剩余本金',
    eachIssueAmount: '每期金额',
    tax5: '税:5',
    tax23: '税:23',
    taxSpecial: '特种营业税',
    taxLocal: '地方收入税',
    handlingFee: '手续费',
    recoveryAmount: '追讨金额',
    // lateFee: '滞纳金',
    deductionFee: '减免金额',
    hadDeductionFee: '已减免金额',

    paymentAmt: '实际到账金额',
    paymentTime: '放款时间',
    selectDate: '选择日期',
    extendAmoumt: '展期金额',
    oxxoCode: 'oxxo 还款码',
    extendOxxoCode: 'oxxo 展期还款码',
    registerTime: '注册时间',
    appName: 'APP',
    ext: '额外信息',
    ext1: '额外信息1',


    //平台放款报表
    loanDate: '放款日期',
    loanPensNum: '放款笔数',
    newAcountsNum: '新户笔数',
    Newhouseholdpartsareall: '新户件均',
    oldAcountsNum: '老户笔数',
    Oldhouseholdpartsareall: '老户件均',
    ProportionOfOldHouseholds: '老户占比',
    loanPrincipal: '放款本金',
    NewHouseholdsPrincipalOfl: '新户放款本金',
    OldHouseholdsPrincipalOfl: '老户放款本金',
    LoanContractAmount: '放款合同额',
    NewHouseholdContractAmount: '新户合同额',
    OldHouseholdContractAmount: '老户合同额',

    //平台放款报表（应用维度）
    appNameValue: 'app名称',
    timeLimit: '期限',
    settlementType: '结清类型',

    //复借率
    rateValue: '费率',
    ActualRepaymentDate: '申请日期',
    ActualNumRepaymentletters: '实际还款笔数',
    ReBorrowOnTheSameDayOfRepay: '还款当天复借',
    ReBorrowOnThe2DayOfRepay: '还款第2天复借',
    ReBorrowOnThe3DayOfRepay: '还款第3天复借',
    ReBorrowOnThe4DayOfRepay: '还款第4天复借',
    ReBorrowOnThe5DayOfRepay: '还款第5天复借',
    ReBorrowOnThe6DayOfRepay: '还款第6天复借',
    ReBorrowOnThe7DayOfRepay: '还款第7天复借',
    reborrowedPensTotalNum: '总复借笔数',
    FirstDayRefinancingRate: '首日复借率',
    SevenDayRefinancingRate: '7日复借率',
    TenDayRefinancingRate: '10日复借率',
    fifteenDayRefinancingRate: '15日复借率',
    ReLendingRate: '复借率',

    //复借率（申请）
    applicationDate: '申请日期',
    applicationsNum: '申请笔数',


    //复贷率统计（按次数）
    expiryDate: '到期日',
    expiredCustomersNum: '到期客户数',
    peopleClearedNum: '结清人数',
    refinancingApplicantsNum: '复贷申请人数',
    peopleRefinancingNum: '复贷人数',
    peoplerefinancing3Days: '复贷人数(3天内)',
    peoplerefinancing7Days: '复贷人数(7天内)',
    peoplerefinancing14Days: '复贷人数(14天内)',
    peoplerefinancing30Days: '复贷人数(30天内)',
    BadDebtRate: '坏账率',
    ReBorrowingRateDueDenominator: '复借率（到期人数为分母）',
    ReBorrowingRateSettledDenominator: '复借率（结清人数为分母）',


    //复借统计
    balanceSheet: '结清单数',
    refinancingApplicaNum: '复贷申请单数',
    RefinanceApplicationRate: '复贷申请率',
    compoundLoanLoansNum: '复贷放款单数',
    MultipleLoanLendingRate: '复贷放款率',


    //回款监控（订单维度）
    dateValue: '日期',
    StatisticalLatitude: '统计纬度',

    //
    beginDateZH: "放款日期",
    adGroupZH: "广告组",
    channelZH: "渠道名称",
    payTotalZH: "放款数量",
    unsettleCountZH: "未结算数量",
    company:"公司", 
    earlySettleCountZH: "提前还款数量",
    settleCountZH: "正常还款数量",
    overdueSettleCountZH: "逾期还款数量",
    overdueRateZH: "逾期率",
    adgroupNameListZH: "广告组名称列表",
    channelListZH: "渠道名称列表",
    
    couponId:"优惠卷 id",
    couponType:"优惠卷类型",
    validStartDate:"开始时间",
    validEndDate:"结束时间",
    cpStatus:"是否使用",
    couponAmount:"优惠卷金额",

    flowId : "还款 id",
    flowChannel: "还款渠道",
    payLink: "还款链接",
    payinId: "支付订单 id",
    payoutId: "系统订单 id",
    repayStatus: "还款状态",
    repayAmount: "还款金额",

    adCost:"广告花费",
    installsCount:"安装数量",
    registryCount:"注册数量",
    applySuccessCount:"申请数量",
    riskPassCount:"风控数量",
    loanSuccessCount:"放款数量",
    roiSeven:"ROI/7天",
    roiFourteen:"ROI/14天",
    roiThirty:"ROI/30",
    roiOther:"ROI/自定义",
    installPrice:"安装单价",
    loanPrice:"放款单价",
    repayDate: '还款日期',
    repayCount: '还款单数',
    repayUserCount: '还款人数',
    repaySumAmout: '还款总金额',
    year:"年份",
    month:"月份",
    loanPersonCount:"放款人数",
    loanCount:"放款单数",
    loanAmount:"放款金额",
    repayPersonCount:"已还人数",
    repayCount:"已还单数",
    repayAmount:"已还金额",
    repayPrincipal:"已还本金",
    repayInterest:"已还利息",
    overduePersonCount:"逾期人数",
    overdueCount:"逾期单数",
    overdueAmount:"逾期金额",
    onOrderPersonCount:"在途人数",
    onOrderCount:"在途单数",
    onOrderAmount:"在途金额"



  },
  ti: {
    repaymentLink:'ลิงค์การชำระคืน',
    sendtipsmsg:'SMS เตือนความจำ',
    username:'ชื่อผู้ใช้',
    monayvalue:'จำนวน',
    orderallmoney:'จำนวนการสั่งซื้อทั้งหมด',
    createOrderDate:'เวลาสร้างลิงค์การชำระคืน',
    ThaibmName: 'ชื่อเล่น',
    ThaiName: 'ชื่อไทย',
    contentValue: 'เนื้อหา',
    witnessScore: 'คะแนนการรับรู้พยาน',
    line: 'line',
    tiktokNumber: 'TikTok บัญชี',
    Currentaddress:'ที่อยู่ปัจจุบัน',
    failedLoanOrder: 'ใบสั่งซื้อล้มเหลว',
    senfEmail: 'ส่งจดหมาย',
    creator: 'ชื่อผู้สร้าง',
    sendSmSSuccess:'ส่งเรียบร้อยแล้ว',
    saveEdit: 'เซฟ',
    cancelSaveEdit: 'ยกเลิกการแก้ไข',
    EditValue: 'แก้ไข',
    deadline: 'ระยะ',
    ProductType: 'ประเภทผลิตภัณฑ์',
    custType: 'ประเภทผู้ใช้',
    loanTime: 'เวลายืม',
    applicationTime: 'เวลาสมัครสินเชื่อ',
    approvalDetail: 'รายละเอียดการอนุมัติ',
    productName: 'ชื่อสินเชื่อ',
    appVersion: 'เวอร์ชันแอป',
    questionType: 'หมวดหมู่คำถาม',
    orderInfo: 'ข้อมูลการกู้สินเชื่อ',

    RegisPhoneNum: 'ลงทะเบียนโทรศัพท์',
    notes: 'หมายเหตุ',
    blackoutTime: 'ดึงเวลาสีดำ',

    repaymentRecord: 'บันทึกการชำระเงินคืน',
    couponRecord:'บันทึกคูปอง',
    applyAmt: 'ยอดกู้สินเชื่อ',
    totalAmount: 'จำนวนเงินทั้งหมด',
    loanDuration: 'จำนวนวันที่กู้',
    card: 'บัตรประชาชน',
    submissionTime: 'เวลายื่นดำเนินการ',
    applicationDeadline: 'ระยะเวลา',
    orderNo: 'หมายเลขคำขอสินเชื่อ',
    amount: 'วงเงินกู้',
    approveBorrowerTotal: 'จำนวนผู้กู้ที่ได้รับอนุมัติ',
    approveBorrowerTotalAmount: 'อนุมัติยอดผู้กู้ทั้งหมด',
    overdueAccountTotal: 'ยอดคงค้างผู้กู้ทั้งหมด',
    overdueAmountTotal: 'ยอดคงค้างของผู้กู้ทั้งหมด',
    addBorrowerTotalAmount: 'เพิ่มยอดผู้กู้รวม',
    addBorrowerTotal: 'จำนวนผู้กู้รายใหม่ทั้งหมด',
    approveBorrowContractTotal: 'จำนวนสัญญากู้ที่อนุมัติทั้งหมด',
    approveBorrowContractTotalAmount: 'จำนวนเงินสัญญากู้ที่อนุมัติทั้งหมด',
    overdueContractAccountTotal: 'จำนวนสัญญากู้ที่ยังไม่ชำระหนี้ทั้งหมด',
    overdueContractAmountTotal: 'จำนวนเงินสัญญากู้ที่ยังไม่ชำระหนี้ทั้งหมด',
    addBorrowContractTotal: 'จำนวนสัญญากู้ที่เพิ่มใหม่ทั้งหมด',
    addBorrowContractTotalAmount: 'จำนวนเงินสัญญากู้ใหม่ทั้งหมด',
    totalNumber: 'จำนวนบัญชีทั้งหมด',
    totalAmounts: 'ยอดรวมสินเชื่อที่ยังไม่ได้ชิมช้อปใช้',
    addAccountTotal: 'จำนวนบัญชีที่เพิ่มเข้ามา',
    addAmountTotal: 'เพิ่มวงเงินกู้',
    overdueAccountTotal1: 'บัญชีที่ค้างชำระ 1 ~ มีนาคม',
    overdueAccountTotal2: 'บัญชีค้างชำระ 3~มิถุนายน',
    overdueAccountTotal3: 'บัญชีที่ค้างชำระ 6 ~ ธันวาคม',
    overdueAccountTotal4: 'บัญชีมากกว่า ธ.ค. ที่ค้างชำระ',
    overdueAmountTotal1: 'ค้างชำระ 1 ~ มีนาคม จำนวน',
    overdueAmountTotal2: 'ค้างชำระ 3 ~ มิถุนายน จำนวน',
    overdueAmountTotal3: 'ค้างชำระ 6 ~ ธันวาคม จำนวน',
    overdueAmountTotal4: 'เกินกำหนดเดือนธันวาคม',
    interest: 'ดอกเบี้ย',
    totalRemainingDebt: 'ยอดหนี้คงเหลือทั้งหมด',
    remainingPrincipal: 'เงินต้นที่เหลือ',
    overdueDays: 'วันที่ค้างชำระ',
    unpaidPrincipal: 'เงินต้นที่ค้างชำระ',
    eachIssueAmount: 'จำนวนเงินต่องวด',
    tax5: 'ภาษี:5',
    tax23: 'ภาษี:23',
    taxSpecial: 'ภาษีธุรกิจพิเศษ',
    taxLocal: 'ภาษีรายได้ท้องถิ่น',
    handlingFee: 'ค่าธรรมเนียมการจัดการ',
    recoveryAmount: 'จำนวนการเรียกคืน',
    orderType: 'ประเภทการสั่งซื้อ',
    paymentAmt: 'จำนวนเงินที่ได้รับจริง',
    selectDate: 'เลือกวันที่',
    extendAmoumt: 'จำนวนเงินแบบโรลโอเวอร์',
    repaymentAmount: 'ยอดเงินที่ต้องชำระคืน',
    settleAmt: 'ยอดเงินที่ชำระคืน',
    lateFee: 'ค่าธรรมเนียมการชำระล่าช้า',
    historicalOrderRecords: 'ประวัติการสั่งซื้อ',
    jointBondOrderRecords: 'บันทึกการสั่งซื้อหนี้ร่วม',
    overdueDayC: 'วันที่เกินกำหนดชำระ',
    reLendingAmount: 'จำนวนสินเชื่อ',
    repayPoint: 'อัตราดอกเบี้ยเงินกู้',

    approvalRecord: 'บันทึกการอนุมัติ',
    calllist:'ประวัติการโทรส่วนตัว',
    callusername:'ชื่อผู้ใช้โทรศัพท์',
    calltimevalue:'ระยะเวลาการโทร (วินาที)',
    RecordingAccessAddress:'ที่อยู่การเข้าถึงการบันทึก',
    connectionTime:'เวลาเชื่อมต่อ',
    hangingUpReason:'เหตุผลที่ต้องวางสาย',
    approvalStaff: 'ชื่อเจ้าหน้าที่อนุมัติ',
    approvalTime: 'ระยะเวลาดำเนินการ',
    approvalTaskStatus: 'ตรวจสอบสถานะ',
    approvalStatus: 'สถานะการอนุมัติ',
    settleStatus: 'สถานะการชำระเงิน',
    settleTime: 'เวลาชำระคืน',
    repayment: 'สินเชื่อคืน',
    approvalRemark: 'หมายเหตุ',

    //平台放款报表
    loanDate: 'วันที่วางเงิน',
    loanPensNum: 'จํานวนปากกา',
    newAcountsNum: 'จํานวนปากกาใหม่',
    Newhouseholdpartsareall: 'รายการใหม่ทั้งหมด',
    oldAcountsNum: 'จํานวนปากกาเก่า',
    Oldhouseholdpartsareall: 'บัญชีเก่าทั้งหมด',
    ProportionOfOldHouseholds: 'แก่กว่า',
    loanPrincipal: 'เงินดาวน์',
    NewHouseholdsPrincipalOfl: 'เงินดาวน์ใหม่',
    OldHouseholdsPrincipalOfl: 'เงินดาวน์บ้านเก่า',
    NewHouseholdContractAmount: 'ยอดสัญญาใหม่',
    OldHouseholdContractAmount: 'สัญญาเก่า',

    //平台放款报表（应用维度）
    appNameValue: 'ชื่อ app',
    timeLimit: ' ระยะเวลา',
    settlementType: 'ประเภทปิดบัญชี',

    //复借率
    settlementTime: 'เวลาปิดบัญชี',
    rateValue: 'อัตรา',
    //复借率
    ActualRepaymentDate: 'วันที่สมัคร',
    ActualNumRepaymentletters: 'จ่ายคืนจริง',
    ReBorrowOnTheSameDayOfRepay: 'วันที่ชำระคืน',
    ReBorrowOnThe2DayOfRepay: 'วันที่ชำระคืนวันที่ 2',
    ReBorrowOnThe3DayOfRepay: 'วันที่ชำระคืนวันที่ 3',
    ReBorrowOnThe4DayOfRepay: 'วันที่ 4 ของการชำระเงินคืน',
    ReBorrowOnThe5DayOfRepay: 'วันที่ 5 ของการชำระเงินคืน',
    ReBorrowOnThe6DayOfRepay: 'วันที่ชำระคืนวันที่ 6',
    ReBorrowOnThe7DayOfRepay: 'วันที่ชำระคืนวันที่ 7',
    reborrowedPensTotalNum: 'จำนวนปากกาทั้งหมด',
    FirstDayRefinancingRate: 'อัตราการกู้ยืมวันแรก',
    SevenDayRefinancingRate: 'อัตราการกู้ยืม 7 วัน',
    TenDayRefinancingRate: 'อัตราการกู้ยืม 10 วัน',
    fifteenDayRefinancingRate: 'อัตราการกู้ยืม 15 วัน',
    ReLendingRate: 'อัตราการกู้ยืม',


    //复借率（申请）
    applicationDate: 'วันที่สมัคร',
    applicationsNum: 'จำนวนใบสมัคร',


    //复贷率统计（按次数）
    expiryDate: 'วันหมดอายุ',
    expiredCustomersNum: 'จำนวนลูกค้าที่หมดอายุ',
    peopleClearedNum: 'จำนวนคนเคลียร์แล้ว',
    refinancingApplicantsNum: 'จำนวนผู้ขอรีไฟแนนซ์',
    peopleRefinancingNum: 'จำนวนผู้รีไฟแนนซ์',
    peoplerefinancing3Days: 'จำนวนผู้รีไฟแนนซ์ (ภายใน 3 วัน)',
    peoplerefinancing7Days: 'จำนวนผู้รีไฟแนนซ์ (ภายใน 7 วัน)',
    peoplerefinancing14Days: 'จำนวนผู้รีไฟแนนซ์ (ภายใน 14 วัน)',
    peoplerefinancing30Days: 'จำนวนผู้รีไฟแนนซ์ (ภายใน 30 วัน)',
    BadDebtRate: 'อัตราหนี้เสีย',
    ReBorrowingRateDueDenominator: 'อัตราการกู้ยืมซ้ำ (จำนวนคนที่ครบกำหนดชำระเป็นตัวส่วน)',
    ReBorrowingRateSettledDenominator: 'อัตราดอกเบี้ยเงินกู้ซ้ำ (จำนวนผู้ที่ชำระหนี้เป็นตัวส่วน)',


    //复借统计
    balanceSheet: 'งบดุล',
    refinancingApplicaNum: 'จำนวนคำขอรีไฟแนนซ์',
    RefinanceApplicationRate: 'อัตราการสมัครรีไฟแนนซ์',
    compoundLoanLoansNum: 'จำนวนสินเชื่อเงินกู้ทบต้น',
    MultipleLoanLendingRate: 'อัตราการให้กู้ยืมสินเชื่อหลายรายการ',


    //回款监控（订单维度）
    dateValue: 'วันที่',
    StatisticalLatitude: 'ละติจูดทางสถิติ',

    couponId:"coupon Id",
    couponType:"ประเภทคูปอง",
    validStartDate:"เวลาเริ่มต้นของคูปอง",
    validEndDate:"เวลาสิ้นสุดของคูปอง",
    cpStatus:"ใช้หรือไม่",
    couponAmount:"จำนวนเงินคูปอง",
    flowId: 'รหัสการชำระคืน',
    flowChannel: 'ช่องทางการชำระคืน',
    payLink: 'ลิงก์การชำระคืน',
    payinId: 'รหัสคำสั่งซื้อการชำระเงิน',
    payoutId: 'รหัสคำสั่งซื้อของระบบ',
    repayStatus: 'สถานะการชำระคืน',
    repayAmount: 'จำนวนเงินที่ชำระคืน',
    repayDate: 'วันชำระคืน',
    repayCount: 'จำนวนใบชำระ',
    repayUserCount: 'จำนวนผู้ชำระคืน',
    repaySumAmout: 'จำนวนเงินชำระรวม',
    year:"ปี",
    month:"เดือน",
    loanPersonCount:"จำนวนผู้กู้",
    loanCount:"จำนวนรายการกู้",
    loanAmount:"จำนวนเงินกู้",
    repayPersonCount:"จำนวนผู้ชำระแล้ว",
    repayCount:"จำนวนรายการชำระแล้ว",
    repayAmount:"จำนวนเงินชำระแล้ว",
    repayPrincipal:"เงินต้นชำระแล้ว",
    repayInterest:"ดอกเบี้ยชำระแล้ว",
    overduePersonCount:"จำนวนผู้ค้างชำระ",
    overdueCount:"จำนวนรายการค้างชำระ",
    overdueAmount:"จำนวนเงินค้างชำระ",
    onOrderPersonCount:"จำนวนผู้อยู่ระหว่างดำเนินการ",
    onOrderCount:"จำนวนรายการอยู่ระหว่างดำเนินการ",
    onOrderAmount:"จำนวนเงินอยู่ระหว่างดำเนินการ"
  },
  en: {
    repaymentLink:'Repayment link',
    sendtipsmsg:'Reminder SMS',
    username:'username',
    monayvalue:'Amount',
    orderallmoney:'The total amount of orders',
    createOrderDate:'Repayment link generation time',
    ThaibmName: 'Thai alias',
    ThaiName: 'Thai name',
    contentValue: 'Content',
    witnessScore: 'Witness recognition score',
    line: 'line',
    Currentaddress:'Current address',
    tiktokNumber: 'TikTok account',
    failedLoanOrder: 'Failed loan order',
    senfEmail: 'Send mail',
    creator: 'Name of creator',
    sendSmSSuccess:'Sent successfully',
    saveEdit: 'Save',
    cancelSaveEdit: 'Cancel Editing',
    EditValue: 'Edit',
    ProductType: 'Product type',
    title: 'Order Management',
    allTitle: 'All Order',
    loanTitle: 'Loan Order',
    pendingTitle: 'Pending Order',
    overdueTitle: 'Overdue Order',
    orderId: 'Order ID',
    orderNo: 'Order number',
    orderType: 'Order Type',
    loanStatus: 'Loan Status',
    loanAmount: 'Loan Amount',
    loanTime: 'Loan Time',
    loanPurpose: 'Loan Purpose',
    loanNumber: 'Loan Number',
    approvalStatus: 'Approval Status',
    settleStatus: 'Settle Status',
    settleTime: 'Settle Time',
    repayment: 'Repayment',
    settlementStatus: 'Settlement Status',
    settlementTime: 'Settlement Time',
    overdueStatus: 'Overdue Status',
    applicationTime: 'Application Time',
    applicationAmount: 'Application Amount',
    deadline: 'the term',
    applicationDeadline: 'Loan Term',
    submissionTime: 'Submission Time',

    RegisPhoneNum: 'Registered phone number',
    notes: 'notes',
    blackoutTime: 'blackoutTime',

    orderDetail: 'Order Detail',
    orderInfo: 'Order Information',
    examineCustomerInfo: 'Examine Customer Infomation',
    examineAddressInfo: 'Examine Address Infomation',
    approvalDetail: 'Approval Detail',
    collectionDetail: 'collection Detail',
    repaymentPlan: 'Repayment Plan',
    historicalOrderRecords: 'Historical order records',
    jointBondOrderRecords: 'Record of joint bond orders',
    totalPeriod: 'Total Period',
    currentPeriod: 'Current Period',
    interest: 'Interest',
    totalRemainingDebt: 'Total Remaining Debt',
    remainingPrincipal: 'Remaining Principal',
    unpaidPrincipal: 'Unpaid Principal',
    tax5: 'tax:5',
    tax23: 'tax:23',
    taxSpecial: 'Special business tax',
    taxLocal: 'Local income tax',
    handlingFee: 'Handling Fee',
    recoveryAmount: 'Recovery Amount',
    startingTime: 'Starting Time',
    totalNumber: 'Total number of accounts',
    totalAmounts: 'Total amount of unpaid loans',
    amount: 'LoanAmount',
    approveBorrowerTotal: 'Total number of approved borrowers',
    approveBorrowerTotalAmount: 'Approve the total amount of the borrower',
    overdueAccountTotal: 'Total number of outstanding borrowers',
    overdueAmountTotal: 'The total amount outstanding from the borrower',
    addBorrowerTotal: 'Total number of newly added borrowers',
    addBorrowerTotalAmount: 'Total amount of newly added borrowers',
    approveBorrowContractTotal: 'Total number of approved borrow Contract',
    approveBorrowContractTotalAmount: 'Approve the total amount of the borrower Contract',
    overdueContractAccountTotal: 'Total number of outstanding borrow Contracts',
    overdueContractAmountTotal: 'The total amount outstanding from the borrow Contract',
    addBorrowContractTotal: 'Total number of newly added borrow Contract',
    addBorrowContractTotalAmount: 'Total amount of newly added borrow Contract',
    addAccountTotal: 'Number of newly added accounts',
    addAmountTotal: 'Newly added loan amount',
    overdueAccountTotal1: 'Accounts overdue for 1-3 months',
    overdueAccountTotal2: 'Accounts overdue for 3-6 months',
    overdueAccountTotal3: 'Accounts overdue for 6-12 months',
    overdueAccountTotal4: 'Accounts overdue for more than 12 months',
    overdueAmountTotal1: 'Overdue amount for 1-3 months',
    overdueAmountTotal2: 'Overdue amount for 3-6 months',
    overdueAmountTotal3: 'Overdue amount for 6-12 months',
    overdueAmountTotal4: 'Amount overdue for more than 12 months',
    expireTime: 'Expire Time',
    totalRepayableAmount: 'Total Repayable Amount',
    principalPayable: 'Principal Payable',
    overdueDays: 'Due date',
    forfeitPenalty: 'Forfeit Penalty',
    status: 'Status',
    productName: 'Product Name',
    appVersion: 'app Name',
    questionType: 'Question category',

    collectionRecord: 'Collection Record',
    collectionStaff: 'Collection Staff',
    collectionTime: 'Collection Time',
    collectionTaskStatus: 'Task Status',
    collectionStatus: 'Collection Status',
    collectionRemark: 'comment',
    followUserName: 'Name of follow-up person',
    followTime: 'Follow Time',
    overdueDay: 'Due date',
    followResult: 'Customer contact information',
    followingUpOrder: 'Following Up Order',
    hasColOrder: 'Has Collection Order',
    repaymentIntention: 'Repayment Intention',

    approvalRecord: 'Approval Record',
    calllist:'Personal call history',
    callusername:'Phone username',
    calltimevalue:'Call duration (seconds)',
    RecordingAccessAddress:'Recording access address',
    connectionTime:'connection time',
    hangingUpReason:'Reason for hanging up',
    approvalStaff: 'Approval Staff',
    approvalTime: 'Approval Time',
    approvalTaskStatus: 'Approval Task Status',
    approvalRemark: 'Approval Remark',

    addressBookList: 'View Address Book',
    addressBookName: 'Address Book Name',
    addressBookPhoneNo: 'Address Book PhoneNo',

    lending: 'Lending',
    isLoan: 'Confirm the loan?',
    location: 'location',
    isRefuseReductionAmt: 'Refuse apply ?',
    custType: 'cust type',

    applyAmt: 'Apply Amt',
    totalAmount: 'Total Amount',
    loanDuration: 'Lan Duration',
    card: 'Card',
    repaymentAmount: 'Loan Amt',
    settleAmt: 'Repayment amount',
    lateFee: 'Late fee ',
    overdueDayC: 'Due date',
    reLendingAmount: 'Number of loans',
    repayPoint: 'Lending Rate',
    linkCondition: ' Contact Information Base ',
    orderNumber: 'Phone number of the user or recent contact',
    capital: 'Principal payable',
    settledCapital: 'Principal paid',
    settledInterest: 'Interest paid',
    // lateFee: 'late fee',
    deductionFee: 'Deduction amount',
    hadDeductionFee: 'Had Deduction amount',
    paymentAmt: 'Actual account amount ',
    paymentTime: 'Loan duration',
    selectDate: 'Select Date',
    extendAmoumt: 'Extension amount',
    oxxoCode: ' Oxxx refund code ',
    extendOxxoCode: 'Oxxo extension repayment Code',
    registerTime: 'Register time',
    appName: 'APP',
    ext: 'ext',
    ext1: 'ext1',

    //平台放款报表
    loanDate: 'Loan date',
    loanPensNum: 'Number of loan pens',
    newAcountsNum: 'The number of new accounts',
    Newhouseholdpartsareall: 'New household parts are all',
    oldAcountsNum: 'The number of old accounts',
    Oldhouseholdpartsareall: 'Old household parts are all',
    ProportionOfOldHouseholds: 'Proportion of old households',
    loanPrincipal: 'Loan principal',
    NewHouseholdsPrincipalOfl: 'Principal of loan for new households',
    OldHouseholdsPrincipalOfl: 'Principal of loan from old households',
    NewHouseholdContractAmount: 'New household contract amount',
    OldHouseholdContractAmount: 'Old household contract amount',

    //平台放款报表（应用维度）
    appNameValue: 'Name app',
    timeLimit: ' Time limit',
    settlementType: 'Settlement type',

    //复借率
    rateValue: 'rate',
    ActualRepaymentDate: 'Application date',
    ActualNumRepaymentletters: 'Actual number of repayment letters',
    ReBorrowOnTheSameDayOfRepay: 'Re-borrow on the same day of repayment',
    ReBorrowOnThe2DayOfRepay: 'Refund on the second day of repayment',
    ReBorrowOnThe3DayOfRepay: 'Refund on the 3rd day of repayment',
    ReBorrowOnThe4DayOfRepay: 'Refund on the 4th day of repayment',
    ReBorrowOnThe5DayOfRepay: 'Refund on the 5th day of repayment',
    ReBorrowOnThe6DayOfRepay: 'Refund on the 6th day of repayment',
    ReBorrowOnThe7DayOfRepay: 'Refund on the 7th day of repayment',
    reborrowedPensTotalNum: 'Total number of re borrowed transactions',
    FirstDayRefinancingRate: 'First day borrowing rate',
    SevenDayRefinancingRate: '7-day borrowing rate',
    TenDayRefinancingRate: '10 day borrowing rate',
    fifteenDayRefinancingRate: '15 day borrowing rate',
    ReLendingRate: 'Borrowing rate',

    //复借率（申请）
    applicationDate: 'Date of Application',
    applicationsNum: 'Number of applications',


    //复贷率统计（按次数）
    expiryDate: 'expiry date',
    expiredCustomersNum: 'Number of expired customers',
    peopleClearedNum: 'Number of people cleared',
    refinancingApplicantsNum: 'Number of refinancing applicants',
    peopleRefinancingNum: 'Number of people refinancing',
    peoplerefinancing3Days: 'Number of people refinancing (within 3 days)',
    peoplerefinancing7Days: 'Number of people refinancing (within 7 days)',
    peoplerefinancing14Days: 'Number of people refinancing (within 14 days)',
    peoplerefinancing30Days: 'Number of people refinancing (within 30 days)',
    BadDebtRate: 'Bad debt rate',
    ReBorrowingRateDueDenominator: 'Re-borrowing rate (the number of people due is the denominator)',
    ReBorrowingRateSettledDenominator: 'Repeat loan rate (the number of people who have settled the loan is the denominator)',

    //复借统计
    balanceSheet: 'Balance sheet',
    refinancingApplicaNum: 'Number of refinancing applications',
    RefinanceApplicationRate: 'Refinance application rate',
    compoundLoanLoansNum: 'Number of compound loan loans',
    MultipleLoanLendingRate: 'Multiple loan lending rate',


    //回款监控（订单维度）
    dateValue: 'date',
    StatisticalLatitude: 'Statistical latitude',

    couponId:"coupon Id",
    couponType:"Coupon type",
    validStartDate:"Coupon Start Date",
    validEndDate:"Coupon End Date",
    cpStatus:"Whether to use",
    couponAmount:"Coupon Amount",

    flowId: "Repayment ID",
    flowChannel: 'Repayment Channel',
    payLink: 'Repayment Link',
    payinId: 'Payment Order ID',
    payoutId: 'System Order ID',
    repayStatus: 'Repayment Status',
    repayAmount: 'Repayment Amount',
    repayDate: 'repay Date',
    repayCount: 'repay Count',
    repayUserCount: 'repay User Count',
    repaySumAmout: 'repay Sum Amout'
  },
  es: {
    title: 'Order Management',
    allTitle: 'All Order',
    loanTitle: 'Loan Order',
    pendingTitle: 'Pending Order',
    overdueTitle: 'Overdue Order',
    orderId: 'ID de pedido',
    orderNo: 'Número de pedido',
    orderType: 'Tipo de pedido',
    loanStatus: 'Loan Status',
    loanAmount: 'Loan Amount',
    loanTime: 'Tiempo de dar prétamo',
    loanPurpose: 'Loan Purpose',
    loanNumber: 'Loan Number',
    approvalStatus: 'Estado de revisión',
    settleStatus: 'Estado del reembolso',
    settlementStatus: 'Estado de liquidación',
    settlementTime: 'Settlement Time',
    overdueStatus: 'Estado de demora',
    applicationTime: 'Application Time',
    applicationAmount: 'Importe solicitado',
    deadline: 'plazo',
    applicationDeadline: 'Período de solicitud',
    submissionTime: 'tiempo de solicitud',

    orderDetail: 'Detalles del pedido',
    orderInfo: 'Información de pedido',
    examineCustomerInfo: 'Examine Customer Infomation',
    examineAddressInfo: 'Examine Address Infomation',
    approvalDetail: 'Approval Detail',
    collectionDetail: 'collection Detail',
    repaymentPlan: 'Plan de pago',
    historicalOrderRecords: 'Registro histórico de pedidos',
    jointBondOrderRecords: 'Registro de pedidos de deuda común',
    totalPeriod: 'Número de plazos totales',
    currentPeriod: 'Número de plazos actuales',
    startingTime: 'tiempo de inicio',
    expireTime: 'tiempo de vencimiento',
    totalRepayableAmount: 'Importe total que debe pagar',
    principalPayable: ' Principal que debe pagar',
    overdueDays: 'Número de días de retraso',
    forfeitPenalty: 'costo por retraso',
    status: 'Estado',
    productName: 'Nombre de app',

    collectionRecord: 'Registro de cobros',
    collectionStaff: 'asesor de cobranza',
    collectionTime: 'tiempo de cobro',
    collectionTaskStatus: 'Estado de la tarea de cobro',
    collectionStatus: 'Collection Status',
    collectionRemark: 'comment',
    followUserName: 'Name of follow-up person',
    followTime: 'Follow Time',
    overdueDay: 'Due date',
    followResult: 'Customer contact information',
    followingUpOrder: 'Following Up Order',
    hasColOrder: 'Has Collection Order',
    repaymentIntention: 'Repayment Intention',

    approvalRecord: 'Registros de aprobación',
    approvalStaff: 'Aprobador',
    approvalTime: 'Tiempo de aprobación',
    approvalTaskStatus: 'Estado de aprobación',
    approvalRemark: 'Observaciones',

    addressBookList: 'View Address Book',
    addressBookName: 'Address Book Name',
    addressBookPhoneNo: 'Address Book PhoneNo',

    lending: 'Lending',
    isLoan: 'Confirm the loan?',
    location: 'location',
    isRefuseReductionAmt: 'Refuse apply ?',
    custType: 'cust type',

    repaymentRecord: 'Registro de pago',
    couponRecord:'Coupon record',
    payOrderNo: 'Número de orden de pago',
    applyAmt: 'Importe solicitado',
    repaymentAmount: 'Importe que debe pagar',
    settleAmt: 'Importe que ha pagado',
    lateFee: 'costo por retraso',
    payType: 'Tipo de pago',
    payAmount: 'Importe del pago',
    payRecipt: 'Número de factura',
    description: 'Descripción',
    errorDescription: 'Descripción del fallo',
    recordTime: 'Fecha de registro',
    overdueDayC: 'Número de días de retraso',
    reLendingAmount: 'Número de préstamos',
    repayPoint: 'Tasa de interés del préstamo',
    linkCondition: ' Contact Information Base ',
    orderNumber: 'Phone number of the user or recent contact',
    capital: 'Principal payable',
    settledCapital: 'Principal paid',
    settledInterest: 'Interest paid',
    // lateFee: 'late fee',
    deductionFee: 'Deduction amount',
    hadDeductionFee: 'Had Deduction amount',

    paymentAmt: 'Importe real recibido',
    paymentTime: 'Tiempo de dar prétamo',
    extendAmoumt: 'Importe de extensión',
    oxxoCode: ' Oxxx refund code ',
    extendOxxoCode: 'Oxxo extension repayment Code',
    registerTime: 'Register time',
    appName: 'APP',
    ext: 'ext',
    ext1: 'ext1',
    repayDate: 'repay Date',
    repayCount: 'repay Count',
    repayUserCount: 'repay User Count',
    repaySumAmout: 'repay Sum Amout',
    year:"Year",
    month:"Month",
    loanPersonCount:"Loan Person Count",
    loanCount:"Loan Count",
    loanAmount:"Loan Amount",
    repayPersonCount:"Repaid Person Count",
    repayCount:"Repaid Count",
    repayAmount:"Repaid Amount",
    repayPrincipal:"Repaid Principal",
    repayInterest:"Repaid Interest",
    overduePersonCount:"Overdue Person Count",
    overdueCount:"Overdue Count",
    overdueAmount:"Overdue Amount",
    onOrderPersonCount:"On Order Person Count",
    onOrderCount:"On Order Count",
    onOrderAmount:"On Order Amount"
  }
}
